/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Card from "components/card";
import axios from "axios";
import {
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { FaAngleLeft } from "react-icons/fa";
import SweetAlert2 from "react-sweetalert2";

import DetailsTab from "./components/DetailsTab";
// import AccessControlTab from "../shared/AccessControlTab";
import SubaccountsTab from "./components/SubaccountsTab";
import { useParams, useNavigate } from "react-router-dom";

const MerchantDetail = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [merchantDetailForEdit, setMerchantDetailForEdit] = useState(null);
  const [isUpdating, setIsUpdating] = useState<boolean>(false);
  const [swalProps, setSwalProps] = useState<any>({});
  const { merchant_id } = useParams();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();

  useEffect(() => {
    const fetchData = async () => {
      await fetchMerchantDetail();
    };

    fetchData();
  }, []);

  const fetchMerchantDetail = async () => {
    try {
      setIsProcessing(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL +
          `/api/merchant/get-merchant-by-id?merchantid=${merchant_id}`
      );

      let merchantData = response.data.merchant?.payload;

      // Check if merchant data exists, if not redirect to merchant listing
      if (!merchantData) {
        console.error("Merchant not found");
        navigate(`/${userRole}/merchants/manage`);
        return;
      }

      setMerchantDetailForEdit(merchantData);
      setIsLoading(false);
      setIsProcessing(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data", error);
      // Redirect to merchant listing page on error
      navigate(`/${userRole}/merchants/manage`);
    }
  };

  return (
    <>
      <Card className="card card-pad !rounded-xl">
        <div className="mb-3 flex items-center">
          <div>
            <button
              type="button"
              onClick={() => navigate(`/${userRole}/merchants/manage`)}
              disabled={isUpdating}
              className="
                mb-1 inline-flex items-center gap-1
                text-sm font-medium text-gray-700
                transition hover:text-gray-700
                disabled:cursor-not-allowed disabled:opacity-40
                dark:text-gray-400 dark:hover:text-white
              "
            >
              <FaAngleLeft className="text-base" />
              <span>Merchants</span>
            </button>

            <h3 className="text-xl font-semibold text-navy-700">
              {(merchantDetailForEdit as any)?.name ||
                (merchantDetailForEdit as any)?.merchant_name ||
                "—"}
            </h3>
          </div>
        </div>

        <Tabs className="mt-3">
          <TabList className="rounded-tl-custom rounded-tr-custom scrollbar-hide flex flex-wrap overflow-x-auto sm:flex-nowrap">
            <Tab
              className={`child-tab rounded-tl-custom rounded-tr-custom sm:text-md whitespace-nowrap bg-white px-4 py-3 pt-4 text-sm text-navy-700 sm:px-6 sm:py-4 sm:pt-6 ${
                isLoading ||
                isUpdating ||
                isProcessing ||
                merchantDetailForEdit === null
                  ? "pointer-events-none opacity-50"
                  : ""
              }`}
            >
              Details
            </Tab>
            <Tab
              className={`child-tab rounded-tl-custom rounded-tr-custom sm:text-md whitespace-nowrap bg-white px-4 py-3 pt-4 text-sm text-navy-700 sm:px-6 sm:py-4 sm:pt-6 ${
                isLoading ||
                isUpdating ||
                isProcessing ||
                merchantDetailForEdit === null
                  ? "pointer-events-none opacity-50"
                  : ""
              }`}
            >
              {merchantDetailForEdit === null
                ? ""
                : (merchantDetailForEdit as any)?.entity_type === "AGNT#"
                ? "Agents"
                : "Subaccounts"}
            </Tab>
          </TabList>

          <TabPanels className="rounded-bl-custom rounded-br-custom border-t border-gray-200 bg-white">
            <TabPanel>
              <DetailsTab
                data={merchantDetailForEdit}
                setSwalProps={setSwalProps}
                isOtherTabUpdating={isUpdating}
              />
            </TabPanel>
            {/* <TabPanel>
            <AccessControlTab
              data={merchantDetailForEdit}
              mode="merchant"
              is_active={merchantDetailForEdit?.is_active}
              auth1={merchantDetailForEdit?.auth1}
              auth2={merchantDetailForEdit?.auth2}
              isProcessing={isProcessing}
              setSwalProps={setSwalProps}
              fetchDetail={fetchMerchantDetail}
              isOtherTabUpdating={isUpdating}
              setIsUpdating={setIsUpdating}
            />
          </TabPanel> */}
            <TabPanel>
              <SubaccountsTab merchant={merchantDetailForEdit} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>

      <SweetAlert2
        {...swalProps}
        customClass={{
          actions: "custom-swal2-popup-action",
          title: "custom-swal2-popup-title",
          confirmButton:
            "custom-swal2-popup-action custom-swal2-popup-action-confirm",
          cancelButton:
            "custom-swal2-popup-action custom-swal2-popup-action-cancel",
        }}
      ></SweetAlert2>
    </>
  );
};

export default MerchantDetail;
